import React from 'react';
import StickyBox from 'react-sticky-box';

import RichTextArticle from './RichText/RichTextArticle';
import TableOfContents from './TableOfContents/TableOfContents';

class ArticleWithToC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sectionRefs: [],
      displaySticky: false,
    };

    this.stickyRef = React.createRef();
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.observer = new IntersectionObserver(([entry]) => {
      this.setState({ displaySticky: entry.isIntersecting });
    });
    this.observer.observe(this.stickyRef?.current);

    typeof window !== 'undefined' && window.addEventListener('scroll', this.handleScroll);

    const { hash } = this.props.location;

    if (typeof window !== 'undefined' && hash) {
      window.requestAnimationFrame(() => {
        const anchor = document.querySelector(hash);
        if (!anchor) return;
        const offset = anchor.getBoundingClientRect().top + window.scrollY;

        window.scroll({ top: offset, left: 0 });
      });
    }
    let sections = [];
    if (this.props.tableOfContents) {
      if (typeof window === 'undefined' || !document) {
        return;
      }
      // get all with tag
      // store sectionId with topPosition
      // apply end at found next section
      // find article bottom
      const sectionRefs = document.querySelectorAll('[data-section-num]');
      const article = document.getElementById('article');
      const header = window.document.getElementById('hero-section');
      const headerHeight = header.getBoundingClientRect().height;
      sectionRefs.forEach((section, i) => {
        let offsetTop = section.offsetTop + headerHeight; //getElemDistance(section);
        let offsetBottom;
        if (sectionRefs[i + 1]) {
          offsetBottom = sectionRefs[i + 1].offsetTop + headerHeight; //getElemDistance(sectionRefs[i + 1]);
        } else {
          const bounds = article.getBoundingClientRect();
          offsetBottom = article.offsetTop + bounds.height; //getElemDistance(article) + bounds.height;
        }

        const item = this.props.tableOfContents.find((item) => item.sectionId === section.id);
        sections.push({
          id: section.id,
          title: item?.title,
          offsetTop: offsetTop + headerHeight,
          offsetBottom: offsetBottom + headerHeight,
          ref: section,
        });
        //console.log(sectionRefs);
      });
    }
    this.setState({ sectionRefs: sections });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    this.observer.disconnect();
  }

  handleScroll() {
    //const headerHeight = 30;

    const scrollPosition = window.scrollY + 30;
    const selected = this.state.sectionRefs.find((ele) => {
      if (ele) {
        const { offsetBottom, offsetTop } = ele;
        return scrollPosition > offsetTop && scrollPosition < offsetBottom;
      }
      return false;
    });

    if (selected && selected.id !== this.state.visibleSection) {
      this.setState({ visibleSection: selected.id });
    } else if (!selected && this.state.visibleSection) {
      this.setState({ visibleSection: undefined });
    }
  }

  render() {
    const { articleOverrides, tableOfContents, additionalResources, article } = this.props;
    const hasSideBar = tableOfContents?.length > 0 || additionalResources?.length > 0;
    return (
      <div ref={this.stickyRef} {...this.props}>
        {hasSideBar && (
          <>
            {/*<StickyNav
              displayNav={this.state.displaySticky}
              visibleSection={this.state.visibleSection}
              title={tableOfContents.title}
              items={tableOfContents}
            />*/}
            <div>
              <StickyBox offsetTop={104} offsetBottom={10}>
                {tableOfContents && (
                  <TableOfContents
                    localLinks={true}
                    title={'Table of Contents'}
                    currentSection={null} //this.state.visibleSection
                    items={tableOfContents}
                  />
                )}
                {additionalResources && (
                  <TableOfContents card title={'Additional Resources'} items={additionalResources} />
                )}
              </StickyBox>
            </div>
          </>
        )}

        <div id={'article'}>
          <RichTextArticle copy={article} optionsOverride={articleOverrides} />
        </div>
      </div>
    );
  }
}

ArticleWithToC.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default ArticleWithToC;
